import { useDispatch } from "react-redux";
import { errorActions } from "../actions";
import { routes } from "../constants";
import { amrPipelineService } from "../services/amr-pipeline.service";
import { useCallback, useEffect, useState } from "react";
import { Transaction } from "../types/amr-pipeline/models/Transaction";

export const useGetTransactionLink = (
    transaction: Transaction,
    isRequesting: boolean
) => {
    const dispatch = useDispatch();
    const [isLinkLoading, setIsLinkLoading] = useState(false);
    const [transactionLink, setTransactionLink] = useState("");

    const requestLink = useCallback(async () => {
        try {
            setIsLinkLoading(true);
            const token: string = await amrPipelineService.receiveShareLink(
                transaction.dealReferenceName,
                transaction.referenceName
            );

            setTransactionLink(
                `${window.location.origin}${routes.transactionDetailUrl(
                    transaction.referenceName,
                    transaction.dealReferenceName
                )}?token=${token}`
            );
        } catch (e) {
            dispatch(errorActions.unexpectedError(e));
        } finally {
            setIsLinkLoading(false);
        }
    }, [transaction, dispatch]);

    useEffect(() => {
        if (isRequesting && !transactionLink) {
            requestLink();
        }
    }, [isRequesting, requestLink, transactionLink]);

    return { transactionLink, isLinkLoading };
};

